export enum PropertyDataType {
  Uninitialized = 0,
  Text,
  Integer,
  Floating,
  Date = 5, // Yes, number 4 is skipped: https://developer.m-files.com/APIs/REST-API/Reference/enumerations/mfdatatype/
  Time,
  Timestamp,
  Boolean,
  Lookup,
  MultiSelectLookup,
  Integer64,
  FILETIME,
  MultilineText,
  ACL,
}
